<script setup lang="ts">
import { ref } from 'vue';
import { FORM_CONTROL_CLASS } from './form-control';

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<{
  id?: string;
  value: string;
  placeholder?: string;
  emitChangeOnInput?: boolean;
  maxLength?: number;
  readonly?: boolean;
  disabled?: boolean;
  type?: string;
  min?: number;
  max?: number;
  step?: number;
}>();

const emits = defineEmits<{
  change: [value: string];
}>();

const handleChange = (e: Event) => {
  emits('change', (e.target as HTMLInputElement).value);
};

const inputRef = ref<HTMLInputElement | null>(null);

const focus = (options?: FocusOptions): void => {
  inputRef.value?.focus(options);
};

defineExpose({
  focus,
});
</script>

<template>
  <div class="flex w-full">
    <input
      v-bind="$attrs"
      :id="props.id"
      ref="inputRef"
      :class="['m-[2px] flex-1', FORM_CONTROL_CLASS]"
      :value="props.value"
      :placeholder="props.placeholder"
      :maxlength="props.maxLength"
      :readonly="props.readonly"
      :disabled="props.disabled"
      :type="props.type || 'text'"
      :min="props.min"
      :max="props.max"
      :step="props.step"
      @change="handleChange"
      @input="(e) => props.emitChangeOnInput && handleChange(e)"
    />
  </div>
</template>
